import React from "react";

import { Alert } from "@mui/material";
import Grid from "@mui/material/Grid2";

interface ErrorPanelProps {
  audienceError?: string | null;
  activationError?: string | null;
  audienceUpdateError?: string | null;
  buildError?: string | null;
  insightError?: string | null;
  variablesError?: string | null;
  exportError?: string | null;
  tempExportError?: boolean;
  invalidVariablesError?: boolean;
  comparisonError?: boolean;
}

const ErrorPanel: React.FC<ErrorPanelProps> = ({
  audienceError,
  activationError,
  audienceUpdateError,
  buildError,
  insightError,
  variablesError,
  exportError,
  tempExportError,
  invalidVariablesError,
  comparisonError
}) => {
  return (
    <>
      {audienceError && (
        <Grid>
          <Alert variant="filled" severity="error">
            Unable to load audience, please check that the audience id is
            correct and try again
          </Alert>
        </Grid>
      )}
      {audienceUpdateError && (
        <Grid>
          <Alert variant="filled" severity="error">
            Unable to update audience, please check that the audience id is
            correct and try again
          </Alert>
        </Grid>
      )}
      {activationError && (
        <Grid>
          <Alert variant="filled" severity="error">
            Unable to load activation, please check that the campaign id is
            correct and try again
          </Alert>
        </Grid>
      )}
      {buildError && (
        <Grid>
          <Alert variant="filled" severity="error">
            {buildError}
          </Alert>
        </Grid>
      )}
      {insightError && (
        <Grid>
          <Alert variant="filled" severity="error">
            Unable to calculate insight, please rebuild the audience and try
            again
          </Alert>
        </Grid>
      )}
      {variablesError && (
        <Grid>
          <Alert variant="filled" severity="error">
            There was a problem loading the data, please try again and contact
            the systems team if the problem persists
          </Alert>
        </Grid>
      )}
      {exportError && (
        <Grid>
          <Alert variant="filled" severity="error">
            There was a problem creating this export, please try again and
            contact the systems team if the problem persists
          </Alert>
        </Grid>
      )}
      {tempExportError && (
        <Grid>
          <Alert variant="filled" severity="error">
            Export is currently disabled for this audience, please rebuild the
            audience in order to enable exports.
          </Alert>
        </Grid>
      )}
      {invalidVariablesError && (
        <Grid>
          <Alert variant="filled" severity="error">
            One or more of the variables in this audience are no longer available.
            The audience insight has been saved and is still accessible, but if you want to re-build
            the audience then you'll need to update the invalid variables below.
          </Alert>
        </Grid>
      )}
      {comparisonError && (
        <Grid>
          <Alert variant="filled" severity="error">
            It was not possible to load the insights for this comparison.
            Please try refreshing the page, or select different audiences to compare.
          </Alert>
        </Grid>
      )}
    </>
  );
};

export default ErrorPanel;
